// Copyright (c) 2019 Deere & Company

import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { getMessages } from '@deere/cps-it.warranty-i18n';

const mapStatetoProps = () => ({
    locale: 'EN',
    messages: getMessages().EN,
});

export default connect(mapStatetoProps, null)(IntlProvider);
